import { render, staticRenderFns } from "./DatePickerButton.vue?vue&type=template&id=5ad762b2&"
import script from "./DatePickerButton.vue?vue&type=script&setup=true&lang=js&"
export * from "./DatePickerButton.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ad762b2')) {
      api.createRecord('5ad762b2', component.options)
    } else {
      api.reload('5ad762b2', component.options)
    }
    module.hot.accept("./DatePickerButton.vue?vue&type=template&id=5ad762b2&", function () {
      api.rerender('5ad762b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ui/DatePicker/components/DatePickerButton.vue"
export default component.exports